import { render, staticRenderFns } from "./ViewBarCode.vue?vue&type=template&id=c0a67846&"
import script from "./ViewBarCode.vue?vue&type=script&lang=js&"
export * from "./ViewBarCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports